import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import {
  Box,
  Container,
  Grid,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import OrderDetailLayout from '../components/OrderDetailLayout';
import LoadingProgress from '../components/LoadingProgress';
import { getOrderDetails } from '../store/orders/orders.action';

function OrderDetails(props) {
  const { id } = useParams();
  const dispatch = useDispatch();

  const orderState = useSelector((state) => state.orderReducer);
  const { loadingOrders } = orderState;

  useEffect(() => {
    dispatch(getOrderDetails(id));
  }, [id, dispatch]);

  return (
    <>
      <Helmet>
        <title>Order info | Rewot dashboard</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              { loadingOrders
                ? (
                  <Box
                    sx={{
                      height: 500,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <LoadingProgress />
                  </Box>
                ) : <OrderDetailLayout />}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

OrderDetails.propTypes = {

};

export default OrderDetails;
